export default __webpack_public_path__ + "static/media/team_about_us.5410353a.svg";